/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_Exit_ComparisonInputs */



/**
* | output |
* | --- |
* | "Exit comparison view" |
*
* @param {Spaces_Floating_Exit_ComparisonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_exit_comparison = /** @type {((inputs?: Spaces_Floating_Exit_ComparisonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Exit_ComparisonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergleichsansicht beenden")
	return /** @type {LocalizedString} */ ("Exit comparison view")
});